import { ACTUATIONS_GRAPH_SCALE_NAME } from '@features/GraphsView/Actuations/Actuations';
import { t } from '@lingui/macro';
import { BoundaryAndActuationsBaseModel } from './MainGraph';

// actuations
export interface ActuationDataModel {
  date: string; // as date
  positiveActuations: number;
  negativeActuations: number;
}

export interface SiteActuationsModel {
  siteId: number;
  actuationData: ActuationDataModel[];
}

export enum GraphActuationsType {
  Positive = 'Positive',
  Negative = 'Negative',
  Total = 'Total',
  Recommended = 'Recommended',
}

export interface ActuationsBaseModel extends BoundaryAndActuationsBaseModel {
  color: string;
}

export const GraphActuationsOptionsFn = (): Record<GraphActuationsType, ActuationsBaseModel> => ({
  [GraphActuationsType.Positive]: {
    label: t({
      message: 'Positive Actuations',
      id: '[MainGraph.PosActuations]',
    }),
    scale: ACTUATIONS_GRAPH_SCALE_NAME,
    state: false,
    color: '#00ff22',
  },
  [GraphActuationsType.Negative]: {
    label: t({
      message: 'Negative Actuations',
      id: '[MainGraph.NegActuations]',
    }),
    scale: ACTUATIONS_GRAPH_SCALE_NAME,
    state: false,
    color: '#ff0022',
  },
  [GraphActuationsType.Total]: {
    label: t({ message: 'Total Actuations', id: '[MainGraph.TotActuations]' }),
    scale: ACTUATIONS_GRAPH_SCALE_NAME,
    state: false,
    color: '#001a5f',
  },
  [GraphActuationsType.Recommended]: {
    label: t({
      message: 'Recommended Maximum Actuator Limit',
      id: '[MainGraph.ThresholdActuations]',
    }),
    scale: ACTUATIONS_GRAPH_SCALE_NAME,
    state: false,
    color: '#cb4b4b',
  },
});
